const APPLICATION_URL = "https://e-learning-dev-96753.firebaseapp.com";

export { APPLICATION_URL };
